(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('qr', qrDirective);

  /** @ngInject */
  function qrDirective($window) {
    return {
      restrict: 'E',
      scope: {
        text: '=',
        size: '=',
        typeNumber: '='
      },
      template: '<canvas></canvas>',
      link: function(scope, element) {
        var canvas = element.find('canvas')[0];
        
        function generateQR() {
          if (!scope.text || !$window.qrcode) {
            return;
          }
          
          var typeNumber = scope.typeNumber || 4;
          var errorCorrectionLevel = 'L';
          var qr = $window.qrcode(typeNumber, errorCorrectionLevel);
          
          qr.addData(scope.text);
          qr.make();
          
          var size = scope.size || 150;
          var moduleCount = qr.getModuleCount();
          var cellSize = size / moduleCount;
          
          canvas.width = size;
          canvas.height = size;
          
          var ctx = canvas.getContext('2d');
          
          for (var row = 0; row < moduleCount; row++) {
            for (var col = 0; col < moduleCount; col++) {
              ctx.fillStyle = qr.isDark(row, col) ? '#000000' : '#ffffff';
              ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
            }
          }
        }
        
        scope.$watch('text', function(newVal) {
          if (newVal) {
            generateQR();
          }
        });
        
        // Initial generation
        if (scope.text) {
          generateQR();
        }
      }
    };
  }
})();
